// src/App.js - VERSION FINALE AVEC THÈME CORRIGÉ ET NOTIFICATIONS FCM + LEADER COMMISSIONS

import React, { useEffect } from 'react'; 
import axios from 'axios'; 
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Register from './components/Register';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Navbar from './components/Navbar';
import Deposit from './components/Deposit';
import Withdrawal from './components/Withdrawal';
import Notifications from './components/Notifications';
import Profile from './components/Profile';
import Leaderboard from './components/Leaderboard';
import PrivateRoute from './components/PrivateRoute'; 
import { SocketProvider } from './SocketContext'; 
import InvestmentConfirmation from './components/InvestmentConfirmation';
import ForgotPassword from './components/ForgotPassword';
import AccountSettings from './components/AccountSettings';
import ResetPassword from './components/ResetPassword';
import GoogleAuthSuccess from './components/GoogleAuthSuccess';
import ReferralPopup from './components/ReferralPopup';
import InvestmentsPage from './components/InvestmentsPage';
import GeminiChatPage from './components/GeminiChatPage';
import InvestmentDetailPage from './components/InvestmentDetailPage'; 
import IndicatorDetail from './components/IndicatorDetail'; 
import WithdrawalsPage from './components/WithdrawalsPage';
import VerifyDeposit from './components/VerifyDeposit';
import LeaderCommissions from './components/LeaderCommissions'; // ✅ AJOUT

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ThemeProvider, useTheme } from './ThemeContext';
import './i18n';

// 🛡️ PATCH : empêche l'erreur insertBefore en production
if (typeof Node !== 'undefined' && Node.prototype) {
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn('Blocked insertBefore on mismatched parent');
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

// 🌐 CONFIGURATION GLOBALE D'AXIOS
axios.defaults.baseURL = (process.env.REACT_APP_API_URL || 'https://api.blackroq.pro').trim();

// 🛠️ SOLUTION POUR L'ERREUR removeChild
if (process.env.NODE_ENV === 'development') {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function(child) {
    if (child && child.parentNode !== this) {
      console.warn('Prevented removeChild error');
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };
}

// 🚀 COMPOSANT PRINCIPAL AVEC THÈME
const ThemedAppContent = () => {
    const { theme } = useTheme();

    return (
        <div className={`app-wrapper ${theme}-mode`}>
            <Navbar />
            
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme={theme}
            />

            <main className="main-content">
                <Routes>
                    {/* Routes publiques */}
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} /> 
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/google-auth-success" element={<GoogleAuthSuccess />} />
                    <Route path="/verify-deposit" element={<VerifyDeposit />} />
                    
                    <Route path="/subscribe" element={<PrivateRoute><InvestmentConfirmation /></PrivateRoute>} />
                    
                    {/* Routes privées */}
                    <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                    <Route path="/deposits" element={<PrivateRoute><Deposit /></PrivateRoute>} />
                    <Route path="/withdrawals" element={<PrivateRoute><Withdrawal /></PrivateRoute>} />
                    <Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
                    <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
                    <Route path="/leaderboard" element={<PrivateRoute><Leaderboard /></PrivateRoute>} />
                    <Route path="/confirm-investment/:plan/:amount" element={<PrivateRoute><InvestmentConfirmation /></PrivateRoute>} />
                    <Route path="/settings" element={<PrivateRoute><AccountSettings /></PrivateRoute>} />
                    <Route path="/mes-investissements" element={<PrivateRoute><InvestmentsPage /></PrivateRoute>} />
                    <Route path="/gemini-chat" element={<PrivateRoute><GeminiChatPage /></PrivateRoute>} />
                    <Route path="/indicators/:key" element={<PrivateRoute><IndicatorDetail /></PrivateRoute>} />
                    <Route path="/mes-investissements/:id" element={<PrivateRoute><InvestmentDetailPage /></PrivateRoute>} />
                    <Route path="/mes-retraits" element={<PrivateRoute><WithdrawalsPage /></PrivateRoute>} />
                    
                    {/* ✅ NOUVELLE ROUTE POUR LES COMMISSIONS LEADER */}
                    <Route path="/mes-commissions" element={<PrivateRoute><LeaderCommissions /></PrivateRoute>} />
                </Routes>
            </main>
            
            <ReferralPopup /> 
        </div>
    );
};

const App = () => {
    
    useEffect(() => {
        // Intercepteur de requêtes Axios
        const requestInterceptor = axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem('token');
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                } else {
                    delete config.headers.Authorization; 
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

        // Enregistrement du token FCM
        const registerFCMToken = async () => {
            try {
                const { requestForToken, sendTokenToBackend, shouldRegisterToken } = require('./firebase/firebase-init');
                const isLoggedIn = !!localStorage.getItem('token');
                
                if (isLoggedIn && shouldRegisterToken()) {
                    console.log('🔄 Tentative d\'enregistrement token FCM...');
                    const fcmToken = await requestForToken();
                    if (fcmToken) {
                        await sendTokenToBackend(fcmToken);
                        console.log('✅ Token FCM enregistré avec succès');
                    }
                }
            } catch (error) {
                console.error('❌ Erreur enregistrement token FCM:', error.message);
            }
        };

        registerFCMToken();

        return () => {
            axios.interceptors.request.eject(requestInterceptor);
        };
    }, []); 

    return (
        <Router>
            <ThemeProvider> 
                <SocketProvider> 
                    <ThemedAppContent />
                </SocketProvider>
            </ThemeProvider>
        </Router>
    );
};

export default App;